export default {
  SET_acquisitions(state, payload) {
    state.acquisitions = payload
  },

  SET_invoices(state, payload) {
    state.invoices = payload
  },

  SET_new_invoice(state, payload) {
    state.new_invoice = payload
  },

  SET_invoice_items(state, payload) {
    state.invoice_items = payload
  },

  SET_acquisitionTypes(state, payload) {
    state.acquisition_types = payload
  },

  SET_acquisitionSources(state, payload) {
    state.acquisition_sources = payload
  },

  SET_acquisitionCategories(state, payload) {
    state.acquisition_categories = payload
  },

  SET_providers(state, payload) {
    state.providers = payload
  },
}
